import Swal from "sweetalert2";
import api from "./api";
import { ModulosDto } from "../shared/dtos/Modulos.dto";


class ModulosService {
  async getAllModulos(): Promise<ModulosDto[]> {
    return api
      .get("/modulos/find-all")
      .then((response) => {
        return Promise.resolve(response.data as ModulosDto[]);
      })
      .catch((error) => {
        this.handleError(error, `Erro ao buscar lotações`);
        return Promise.reject(error);
      });
  }


  private handleError(error: any, message: string): void {
    if (error.response) {
      Swal.fire({
        title: "Erro",
        text: `${message}: ${error.response.data}`,
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    } else {
      Swal.fire({
        title: "Erro",
        text: `${message}: ${error.message || "Erro desconhecido"}`,
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    }
  }
}

const modulosService = new ModulosService();
export default modulosService;
